import React from 'react';
import {CoveragesItem} from '../Coverages';
import '../styles.scss';
import CoverageCard from '../../../components/coverage-card';
export interface CoveragesItemProps {
  coveragesItem: CoveragesItem;
  details?: boolean;
}

function CoveragesListItem({
  coveragesItem,
  details,
}: CoveragesItemProps) {
  return (
    <>
      <CoverageCard 
        details={details}
        coveragesItem={coveragesItem}
      />
      {!details && <div className="coverages-list-line"></div>}
    </>
  );
}


export default CoveragesListItem;
